import { SliderSingleProps } from 'antd';
import React from 'react';
import { withTheme } from 'styled-components';
import { FormLabel } from '../FormLabel';
import { useTheme } from '../ThemeProvider';
import { StyledRangeSLider } from './styles';

export interface RangeSliderProps extends SliderSingleProps {
  label?: string | React.ReactNode;
  error?: string;
  help?: string | React.ReactNode;
  required?: boolean;
}

const RangeSliderComponent = React.forwardRef<HTMLDivElement, RangeSliderProps>((props, ref) => {
  const { label, required, help, error, ...rest } = props;
  const { theme } = useTheme();

  return (
    <div ref={ref}>
      {label || help ? <FormLabel label={label} help={help} required={required} /> : null}
      <StyledRangeSLider {...rest} />
      {error && (
        <span
          className="w-full font-normal text-xs text-left mt-1 "
          style={{ color: theme.colors.error.main.text }}
        >
          {error}
        </span>
      )}
    </div>
  );
});

RangeSliderComponent.displayName = 'RangeSliderComponent';

export const RangeSlider = withTheme(RangeSliderComponent);
